import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetAllCompanies } from "../api/utility/companyAPI";
import { useSelector } from "react-redux";
import { SET_COMPANY, SET_FINANCIAL_YEAR } from "../redux/actionTypes";
import { useDispatch } from "react-redux";
import { showToast } from "../components/ToastifyNotification";
import { GetAllFinancialYears } from "../api/utility/financialYearAPI";

const FinancialYearSelection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [financialYears, setFinancialYears] = useState([]);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);

  const isAuthenticated = useSelector(state => state?.authReducer?.isAuthenticated || false);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(`/login`);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    const fetchFinancialYears = async () => {
      const res = await GetAllFinancialYears();
      if (res?.success) setFinancialYears(res.data);
    };
    fetchFinancialYears();
  }, []);

  const handleFinancialYearSelect = async (financialYear) => {
    setSelectedFinancialYear(financialYear);
  }
  const handleProceed = () => {
    if (!selectedFinancialYear) {
      showToast("error", "Please select a company");
      return;
    }

    dispatch({ type: SET_FINANCIAL_YEAR, payload: selectedFinancialYear });

    navigate("/dashboard/default");
  };

  return (
    <div className="page-wrapper">
      <div className="container-fluid p-0">
        <div className="authentication-main">
          <div className="row">
            <div className="col-md-12">
              <div className="auth-innerright">
                <div className="authentication-box">
                  {/* Header */}
                  <div className="text-center">
                    HOSPITAL MANAGEMENT SOFTWARE
                  </div>

                  <div className="card mt-4">
                    <div className="card-body">
                      <div className="text-center">
                        <h4>SELECT FINANCIAL YEAR</h4>
                        <h6>Please choose your financial year to continue</h6>
                      </div>

                      <div className="theme-form mt-4">
                        <div className="form-group">
                          {financialYears.map(financialYear =>
                            <div key={financialYear._id} className="form-check mb-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="financialYear"
                                id={`financialYear-${financialYear._id}`}
                                value={financialYear._id}
                                onChange={() => handleFinancialYearSelect(financialYear)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`financialYear-${financialYear._id}`}
                              >
                                {financialYear.name}
                              </label>
                            </div>
                          )}
                        </div>

                        <div className="form-group form-row mt-4 mb-0 d-grid">
                          <button
                            className="btn btn-primary"
                            onClick={handleProceed}
                            disabled={!selectedFinancialYear}
                          >
                            OK / Proceed
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancialYearSelection;
